// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes, { func } from 'prop-types';

/**
 * SearchBox
 * @return {JSX} React Element
 */
function SearchBox({
  styleName, placeholder, onChange, value,
}) {
  return (
    <div className={`gx-search-bar ${styleName}`}>
      <div className="gx-form-group">
        <input
          className="ant-input"
          type="search"
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
        <span className="gx-search-icon gx-pointer"><i className="icon icon-search" /></span>
      </div>
    </div>
  );
}

SearchBox.defaultProps = {
  styleName: '',
  placeholder: '',
  onChange: func,
  value: '',
};

SearchBox.propTypes = {
  styleName: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default SearchBox;
